export class Tipo {

    public id:number;
    public tipo:string;
    public valor:string;
    public descripcion:string;
    public codigoTipo:string;

}



// WEBPACK FOOTER //
// D:/TPL ILG/3PL_ILG/src/app/model/tipo.ts